export default {
      id: "Icon--record-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--record",
      toString: function () {
        return this.url;
      }
    }